import type { FunctionComponent } from "react";
import type { IProps } from "./stepped-modal-step.types";

/**
 * Declares one step of a SteppedModal. The parent renders the step's label in the header
 * stepper and this component's children in the modal body when the step is active. `label` is read
 * from this element by the parent rather than used here.
 */
const SteppedModalStep: FunctionComponent<IProps> = ({ children }) => {
    return <>{children}</>;
};

export { SteppedModalStep };
